import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { bottomButton } from "../../common/styles";
import { Header, MainColorButton } from "../../components";
import {
  INSURANCE_INFORMATION,
  PRESCRIPTION_RESERVATION,
} from "../../routes/path";
import store from "../../store";
import { setPrescriptionDirector } from "../../store/actions/prescription";

/**
 * 薬局情報
 * @returns
 */
const PrescriptionDirector = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();
  const [director, setDirector] = useState("3");
  const location = useLocation();
  const preState = location.state.guideType || false;

  useEffect(() => {
    store.dispatch(
      setPrescriptionDirector({
        id: director,
      })
    );
  }, []);

  return (
    <>
      <div
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <Header title="処方箋申込[服薬指導]" />
        <Box
          height="76vh"
          marginTop="9vh"
          width="95%"
          marginLeft="auto"
          marginRight="auto"
        >
          <Stack>
            <Typography variant="subtitle1" align="left">
              服薬指導を選択してください。
            </Typography>
            <Box
              width="85%"
              marginLeft="auto"
              marginRight="auto"
              marginTop="5%"
            >
              <FormControl fullWidth>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={director}
                  onChange={(event) => {
                    setDirector(event.target.value);
                    store.dispatch(
                      setPrescriptionDirector({
                        id: event.target.value,
                      })
                    );
                  }}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="3"
                    control={<Radio />}
                    label="ビデオ通話"
                  />
                  <Box marginLeft="5%" marginBottom="3%">
                    <FormControl fullWidth>
                      {preState ? (
                        <Typography variant="body2">
                          ※お会計はオンライン決済となります。
                        </Typography>
                      ) : (
                        <Typography variant="body2">
                          ※お会計は店舗での支払となります。
                        </Typography>
                      )}
                    </FormControl>
                  </Box>
                  {!preState && (
                    <>
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="対面"
                      />
                      <Box marginLeft="5%">
                        <FormControl fullWidth>
                          <Typography variant="body2">
                            ※お会計は店舗での支払となります。
                          </Typography>
                        </FormControl>
                      </Box>
                    </>
                  )}
                </RadioGroup>
              </FormControl>
            </Box>
          </Stack>
        </Box>
        <MainColorButton
          label="次へ"
          onClick={() => {
            navigate(
              director === "1"
                ? INSURANCE_INFORMATION
                : PRESCRIPTION_RESERVATION,
              { state: location.state }
            );
          }}
          style={bottomButton}
        />
      </div>
    </>
  );
};

export default PrescriptionDirector;
